export default "__VITE_ASSET__hVF5vCRC__"